import PropTypes from 'prop-types';
import React from 'react';

/**
 * shown when the upline agency has disabled onboarding invites for this agency.
 * @param agencyInformation - agency data used to name the upline agency
 */
export default function InvitesDisabledMessage({ agencyInformation }) {
  return (
    <>
      <h2>
        Onboarding forms have been disabled by your upline{' '}
        {agencyInformation?.Parent_Agency?._name?._value}
      </h2>
      <p>
        Please contact{' '}
        <span style={{ fontWeight: 'medium', color: '#3f88bb' }}>
          support@oneillmarketing.net
        </span>{' '}
        to get it reinstated.
      </p>
    </>
  );
}

InvitesDisabledMessage.propTypes = {
  agencyInformation: PropTypes.object
};
